import { jsxs as t, jsx as i } from "react/jsx-runtime";
import o from "../card-trailer/card-trailer.js";
import e from "./trailer-card-list.module.less.js";
const c = ({ heading: l, text: a, cardList: s }) => /* @__PURE__ */ t("div", { className: e.wrapper, children: [
  l && /* @__PURE__ */ i("h4", { className: e.heading, children: l }),
  a && /* @__PURE__ */ i("p", { children: a }),
  /* @__PURE__ */ i("div", { className: [e.list, "space-my-md"].join(" "), children: s?.map((r) => /* @__PURE__ */ i(
    o,
    {
      trailer: r.trailer,
      onClick: r.onClick,
      notAvailable: r.notAvailable
    },
    `${r.trailer.id}-${r.trailer.stationName}`
  )) })
] });
export {
  c as default
};
